import { render, staticRenderFns } from "./LeccionB6.vue?vue&type=template&id=bfa0d5a2&"
import script from "./LeccionB6.vue?vue&type=script&lang=js&"
export * from "./LeccionB6.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports